module.exports = __webpack_public_path__ + "static/img/button_03.1b427f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/button_03.png
// module id = qzj1
// module chunks = 2